import { __assign } from "tslib";
import * as React from "react";
var SvgTomIconZattini = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 120.5 120.5" }, props),
    React.createElement("path", { d: "M0 0h120.5v120.5H0z", style: {
            strokeWidth: 0,
        } }),
    React.createElement("path", { d: "M86.8 93.64V92H34.79c4.38-8.76 25.73-48.72 25.73-48.17H33.7v49.82h53.1ZM59.98 76.67H86.8V26.86H33.7v1.64h52.01c-4.38 8.21-25.73 48.17-25.73 48.17", style: {
            strokeWidth: 0,
            fill: "#fff",
        } }))); };
export default SvgTomIconZattini;
//# sourceMappingURL=TomIconZattini.js.map